<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    multiple
    chips
    deletable-chips
    small-chips
    item-text="identificador"
    item-value="id"
    label="Cotações"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    v-bind="$attrs"
  />
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CotacaoService from '@/modules/cotacao/cotacao-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    buildFilter(val) {
      let filter = `identificador like "%${val.toLowerCase()}%"`;
      if (this.value && this.value.length) {
        // todo: ajustar quando liberar versão do querify
        const ids = this.value.map(cot => cot.id)
          .join(' and id != ');
        filter = `${filter} and id != ${ids}`;
      }
      return `${filter} order by createdIn desc`;
    },
    seachCotacoes(val) {
      if (!val) {
        return;
      }

      this.loading = true;
      CotacaoService.getCotacoes({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildFilter(val),
      })
        .then((response) => {
          this.items = response.data.content;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
  },
  created() {
    this.debounceSearch = debounce(this.seachCotacoes, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
